/// <amd-module name="Environments/EnvironmentsSecurity/Stores/EnvironmentsSecurityStores" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { EnvironmentSecurityActions } from "Environments/EnvironmentsSecurity/Actions/EnvironmentsSecurityActions";
import { EnvironmentInstance, EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";
import { StoreBase, IStoreState } from "Environments/Flux/Store";

export interface IEnvironmentsSecurityStoreState extends IStoreState {
    environment: EnvironmentInstance;
}

export class EnvironmentsSecurityStore extends StoreBase {
    public static getKey(): string {
        return "environments-security-store";
    }

    public initialize(instanceId: string): void {
        super.initialize(instanceId);

        this._actionsHub = ActionsHubManager.GetActionsHub<EnvironmentSecurityActions>(EnvironmentSecurityActions, instanceId);
        this._actionsHub.setEnvironment.addListener(this._handleSetEnvironment);
    }

    protected disposeInternal(): void {
        this._actionsHub.setEnvironment.removeListener(this._handleSetEnvironment);
    }
    
    public getState(): IEnvironmentsSecurityStoreState {
        return this._state;
    }

    public getEnvironment(): EnvironmentInstance {
        return this._state.environment;
    }
    
    private _handleSetEnvironment = (environment: EnvironmentInstance) => {
        this._state.environment = environment;
        this.emitChanged();
    }

    private _actionsHub: EnvironmentSecurityActions;
    private _state: IEnvironmentsSecurityStoreState = {} as IEnvironmentsSecurityStoreState;
}